import axios from "axios";
import { Log } from "../components/shared/utility";

import { getFirebaseToken } from "../firebase";

axios.interceptors.request.use(
  async (config) => {
    await getFirebaseToken()
      .then((token) => {
        Log("Token: " + token);
        config.timeout = 10000;
        config.baseURL = process.env.REACT_APP_BACKEND_SERVER_ADDRESS;
        config.headers = { Authorization: "Bearer " + token };
      })
      .catch((err) => {
        Promise.reject(err);
      });
    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);

const AxiosInstancePublicFiles = axios.create({
  baseURL: "https://language_delete.storage.googleapis.com",
  timeout: 10000,
});

export const GetTranslationsFile = () => {
  return new Promise((resolve, reject) => {
    AxiosInstancePublicFiles({
      method: "GET",
      url: "translations.json",
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const get = (url, params) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response ? error.response.status : 503));
  });
};

export const getAll = (options) => {
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response ? error.response.status : 503);
      });
  });
};

export const post = (url, data, params) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        params,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response ? error.response.status : 503));
  });
};
export const put = (url, data, params) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, {
        params,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response ? error.response.status : 503));
  });
};
export const patch = (url, data, params) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(url, data, {
        params,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response ? error.response.status : 503));
  });
};

export const del = (url, params) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response ? error.response.status : 503));
  });
};
